<template>
  <v-app id="inspire">
    <v-navigation-drawer
      v-model="drawer"
      app
      clipped
      v-if="$store.getters.user && $user.userType!='user' && $user.userType!='business' && $route.path.includes('agent')==true"
    >
       <v-expansion-panels v-if="$store.getters.user">

          <v-expansion-panel style="" class="mb-0">
            <v-expansion-panel-header>Businesses</v-expansion-panel-header>
              <v-expansion-panel-content>
                        <v-list dense="dense">
                            <v-list-item link>
                              <v-list-item-title @click="$router.push('/agent/businesslist')">Business List</v-list-item-title>
                            </v-list-item>
                          <v-list-item link>
                              <v-list-item-title @click="$router.push('/agent/createbusiness')">Business Create</v-list-item-title>
                          </v-list-item>
                        </v-list>
              </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel style="" class="mb-0">
            <v-expansion-panel-header>Business New</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-list dense="dense">
                <v-list-item link>
                  <v-list-item-title @click="$router.push('/agent/createbusinessnew')">Business Create New</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel style="" class="mb-0">
            <v-expansion-panel-header>Tags</v-expansion-panel-header>
              <v-expansion-panel-content>
                        <v-list dense="dense">
                            <v-list-item link>
                              <v-list-item-title @click="$router.push('/agent/tagslist')">Tags List</v-list-item-title>
                            </v-list-item>
                          <!-- <v-list-item link>
                              <v-list-item-title @click="$router.push('/agent/createbusiness')">Business Create</v-list-item-title>
                          </v-list-item> -->
                        </v-list>
              </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel style="" class="mb-0" v-if="isspecialAgent==true">
          <v-expansion-panel-header>Agents</v-expansion-panel-header>
            <v-expansion-panel-content>
                      <v-list dense="dense">
                          <v-list-item link>
                            <v-list-item-title @click="$router.push('/agent/agentlist')">Agent List</v-list-item-title>
                          </v-list-item>
                        <v-list-item link>
                             <v-list-item-title @click="$router.push('/agent/createagent')">Agent Create</v-list-item-title>
                        </v-list-item>
                      </v-list>
            </v-expansion-panel-content>
        </v-expansion-panel>
          <v-expansion-panel style="" class="mt-0">
            <v-expansion-panel-header>Profile</v-expansion-panel-header>
              <v-expansion-panel-content>
                        <v-list dense="dense">
                            <v-list-item link>
                              <v-list-item-title @click="$router.push('/agent/editprofile')">Edit Profile</v-list-item-title>
                            </v-list-item>
                          <v-list-item link>
                              <v-list-item-title @click="$router.push('/agent/changepassword')">Change Password</v-list-item-title>
                          </v-list-item>
                        </v-list>
              </v-expansion-panel-content>
          </v-expansion-panel>

       </v-expansion-panels>
    </v-navigation-drawer>

    <v-app-bar app clipped-left  v-if="$store.getters.user && $user.userType!='user' && $user.userType!='business'">
       <v-app-bar-nav-icon @click.stop="drawer = !drawer" v-if="$store.getters.user"/>

       <v-toolbar-title class="pt-2">
        <router-link to="/agent/dashboard">

          <img :src="logoimg" style="margin-top:5px;margin-bottom:5px;" height="60">
        </router-link>
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <v-menu offset-y v-if="$store.getters.user">
        <template v-slot:activator="{ on }">
          <v-avatar v-on="on">
            <img :src="$user.userType=='agent'?$user.agent.photo:($user.userType=='business'?$user.business.logo:'')" :alt="$user.name" />
          </v-avatar>
        </template>
        <v-card tile>
          <v-list>
            <v-list-item>
              <v-list-item-avatar >
                <img :src="$user.userType=='agent'?$user.agent.photo:($user.userType=='business'?$user.business.logo:'')" :alt="$user.name" />
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title>{{JSON.parse($store.getters.user).name}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>

          <v-divider></v-divider>
          <v-list>
            <v-list-item-group>
            <v-list-item >
              <v-list-item-content>
              <v-list-item-title @click="$router.push('/agent/dashboard')">Dashboard</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-title @click="$router.push('/agent/businesslist')">Businesses</v-list-item-title>
            </v-list-item>

            </v-list-item-group>
          </v-list>

          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="primary" text @click="$router.push('/agent/changepassword')" >Change Password</v-btn>
            <v-btn color="error" text @click="logout">Logout</v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
    </v-app-bar>

    <v-content>
      <router-view />
    </v-content>
  </v-app>
</template>

<script >
import Vue from "vue";

export default Vue.extend({
  name: "App",
  data: () => ({
    logoimg:require("@/assets/logo.svg"),
    drawer: null,
    agentid:0,
    usert:[],
    //userimg:'https://cdn.vuetifyjs.com/images/john.jpg',
     userimg:'',
     isspecialAgent:false,
    //  agenturl:false,
  }),
  created() {

     if(Object.keys(this.$user).length!=0 && (this.$user.userType=='agent'))
     {

       if(this.$user.agent.agenttype=='Special Agent')
       {

          this.isspecialAgent=true;
       }else{
          this.isspecialAgent=false;
       }
     }

    //  if(window.location.href.indexOf('agent') > -1)
    //  {
    //    //alert('agent found');
    //    this.agenturl=true;
    //  }
    //  else
    //  {
    //    this.agenturl=false;
    //    //alert('agent not found');

    //  }

      // this.loadData();
  },
  mounted()
  {
    // if(window.location.href.indexOf('agent') > -1)
    //  {
    //    //alert('agent found');
    //    this.agenturl=true;
    //  }
    //  else
    //  {
    //    this.agenturl=false;
    //    //alert('agent not found');

    //  }
    let ag=this.$route.path;
    console.info('App currentRoute:', ag.includes('bus'))
  },
  
  methods: {

    loadData: function() {
        var self = this;
        setTimeout(function() {
            console.log("times over");
            
            if(window.location.href.indexOf('agent') > -1)
            {
              //alert('agent found');
              self.agenturl=true;
            }
            else
            {
              self.agenturl=false;
              //alert('agent not found');

            }

        }, 2000);
    },

    logout() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push("/login");
      });
    }
  }
});
</script>
<style >
.w-100{
  width: 100%;
}

</style>
